import { createApp, h } from 'vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue3'

// Vue-Select
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

// Sweet Alert
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import moment from 'moment'

import {
  faUser,
  faUsers,
  faHatCowboy,
  faPersonMilitaryPointing,
  faKey,
  faCheck,
  faPlus,
  faPencil,
  faTrash,
  faBars,
  faFloppyDisk,
  faBuildingColumns,
  faGraduationCap,
  faFileContract,
  faArrowLeft,
  faPaperPlane,
  faMagnifyingGlass,
  faBan,
  faXmark,
  faListCheck,
  faChevronRight,
  faSquarePollVertical,
  faCircleArrowRight,
  faCalculator,
  faCircleXmark,
  faCircleCheck,
  faFilePdf,
  faFileExcel,
  faPrint,
  faCircleExclamation
} from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add(faUser)
library.add(faUsers)
library.add(faHatCowboy)
library.add(faPersonMilitaryPointing)
library.add(faKey)
library.add(faCheck)
library.add(faPlus)
library.add(faPencil)
library.add(faTrash)
library.add(faBars)
library.add(faFloppyDisk)
library.add(faBuildingColumns)
library.add(faGraduationCap)
library.add(faFileContract)
library.add(faArrowLeft)
library.add(faPaperPlane)
library.add(faMagnifyingGlass)
library.add(faBan)
library.add(faXmark)
library.add(faListCheck)
library.add(faChevronRight)
library.add(faSquarePollVertical)
library.add(faCircleArrowRight)
library.add(faCalculator)
library.add(faCircleXmark)
library.add(faCircleCheck)
library.add(faFilePdf)
library.add(faFileExcel)
library.add(faPrint)
library.add(faCircleExclamation)
InertiaProgress.init()

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => title ? `${title} - SICERDAS` : 'SICERDAS',
  setup({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) })
      .mixin({
        components: { FontAwesomeIcon, vSelect },
        methods: {
          can(permission) {
            return this.$page.props.auth.user.permissions.includes(permission)
          },
          // Aplikasi berstatus arsip: seluruh aksi tulis dinonaktifkan.
          isReadOnly() {
            const archive = this.$page.props.archive
            return !!(archive && archive.readonly)
          },
          // Dipakai untuk menyembunyikan tombol aksi (verifikasi, tolak,
          // batalkan, dsb.) yang izinnya juga mengatur navigasi baca.
          canWrite(permission) {
            return this.isReadOnly() ? false : this.can(permission)
          },
          route: window.route,
        },
      })
    app.config.globalProperties.$filters = {
      formatShortDate(value) {
        return moment(String(value)).format('DD-MM-YYYY')
      },
      formatNumber(value) {
        var formatter = new Intl.NumberFormat('id-ID', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
        return formatter.format(value)
      },
    }
    app.use(VueSweetalert2)
    app.use(plugin)
    app.mount(el)
  },
})
